import { createContext, useContext } from 'react';

export interface AssetKitColor {
  name?: string;
  value: string;
}

export interface AssetKitFont {
  family: string;
  weight?: number;
  italic?: boolean;
  url: string;
}

export interface AssetKitImage {
  name: string;
  url: string;
}

/** A brand asset the Brand tab offers behind brand-identity-v2 (MPN-2031). */
export interface AssetKitAsset {
  name: string;
  url: string;
  /** Read off the file by the server: "image" or "video" ("other" is never offered). */
  mediaType: string;
  /** The heading it is listed under, one per kind of brand asset: "Logos", "Icons", ... */
  group: string;
}

/**
 * A brand typography style behind brand-identity-v2 (MPN-2033). Applying one copies its
 * family onto a text layer; the layer keeps no link to the style.
 */
export interface AssetKitTypographyStyle {
  name: string;
  category: string;
  family: string;
  source: 'google' | 'uploaded';
}

export interface AssetKit {
  colors: AssetKitColor[];
  fonts: AssetKitFont[];
  /** The Brand tab's logos with brand-identity-v2 off. */
  images: AssetKitImage[];
  /** Every brand asset, in Branding-tab order; the Brand tab's source with brand-identity-v2 on. */
  assets?: AssetKitAsset[];
  /** The brand's typography styles; only with brand-identity-v2 on. */
  typography?: AssetKitTypographyStyle[];
}

const AssetKitContext = createContext<AssetKit | null>(null);

export const AssetKitProvider = AssetKitContext.Provider;
export const useAssetKit = () => useContext(AssetKitContext);
